import { render, staticRenderFns } from "./ContractAndDeclarer.vue?vue&type=template&id=ca511d64&scoped=true&"
import script from "./ContractAndDeclarer.vue?vue&type=script&lang=js&"
export * from "./ContractAndDeclarer.vue?vue&type=script&lang=js&"
import style0 from "./ContractAndDeclarer.vue?vue&type=style&index=0&id=ca511d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca511d64",
  null
  
)

export default component.exports